<template>
  <div>
    <label
      v-if="label"
      class="block text-sm font-medium leading-5 text-gray-700"
      >{{ label }}</label
    >
    <div class="mt-1 relative group">
      <div
        v-if="hasIcon"
        class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
      >
        <!-- Heroicon name: mail -->
        <svg
          class="w-4 h-4 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
      </div>
      <textarea
        v-autosize
        class="rounded border focus:border-2 outline-none focus:border-yellow-500 py-3 block w-full pr-12 sm:text-sm sm:leading-5 text-gray-700"
        :class="[hasIcon ? 'pl-10' : 'pl-3']"
        :placeholder="placeholder"
        :value="value"
        :rows="rows"
        @input="setValue($event.target.value)"
      ></textarea>
      <div
        v-if="clearable"
        class="absolute inset-y-0 right-0 pr-3 flex items-center"
      >
        <svg
          v-if="!!value"
          class="w-5 h-5 text-gray-400 hover:text-gray-500 opacity-0 group-hover:opacity-100 hover:cursor-pointer"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          @click="clearInput()"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import autosize from '@/directives/autosize'
import { ref } from '@vue/composition-api'

export default {
  directives: { autosize },
  props: {
    label: {
      type: String,
    },
    value: {
      type: [String, Number],
    },
    placeholder: {
      type: String,
      default: '',
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    hasIcon: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Number,
      default: 1,
    },
  },
  setup(props, { emit }) {
    const setValue = (value) => {
      emit('input', value)
    }

    const clearInput = () => {
      setValue('')
    }
    return {
      emit,
      setValue,
      clearInput,
    }
  },
}
</script>
